import { Parser } from "html-to-react";
import { useEffect, useState } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { tagsEnvironment } from "~/lib/base";

type State = {
  tags: Tags | null;
};

type Tags = {
  body: string;
  head: string;
};

const parser = Parser();

export default function Tags() {
  const { showBoundary } = useErrorBoundary();
  const [state, setState] = useState<State>({ tags: null });

  useEffect(() => {
    async function run() {
      if (tagsEnvironment === undefined || tagsEnvironment === "none") {
        return;
      }

      let url = "/webhooks/webgazer-tags";

      if (tagsEnvironment !== "") {
        url += `?environment=${tagsEnvironment}`;
      }

      const response = await fetch(url);
      const responseJson: Tags = await response.json();

      setState((s) => ({ ...s, tags: responseJson }));
    }

    run();
  }, [showBoundary]);

  return (
    <>
      {state.tags?.head !== undefined ? parser.parse(state.tags.head) : null}

      {state.tags !== null && state.tags.body !== "" ? parser.parse(state.tags.body) : null}
    </>
  );
}
